export type TColors = 'blue' | 'gray';

export enum ELabelType {
  Reliable = 'reliable',
  Escrow = 'escrow',
}

export interface ILabelsProps {
  key: ELabelType;
  text: string;
  color: TColors;
  icon?: React.ReactElement;
  tooltipContent?: React.ReactNode;
  tooltipTitle?: string;
}
